<script setup lang="ts">
  import { inject, useCssModule } from 'vue';

  import { RADIO_GROUP_INJECTION } from '../RadioGroup.keys';

  const radioGroupInjection = inject(RADIO_GROUP_INJECTION.key);

  if (!radioGroupInjection) {
    throw new Error('VariantRadio must be used with a RadioGroup instance.');
  }

  const { name, disabled, fullWidth, modelValue, options, update } = radioGroupInjection;
  const classes = useCssModule();
</script>

<template>
  <div class="flex flex-wrap" :class="classes.root">
    <div v-for="option in options" :key="`${name}-${option.id}`" :class="[{ 'w-full': fullWidth }]">
      <input
        :id="`${name}-${option.id}`"
        type="radio"
        :name="name"
        :value="option.value"
        :checked="modelValue === option.value"
        :disabled="disabled || option.disabled"
        @input="update"
      />
      <label :for="`${name}-${option.id}`">
        {{ option.text }}
      </label>
    </div>
  </div>
</template>

<style module>
  @reference "../../../../styles/main.css";

  @layer utilities {
    .root {
      gap: --spacing(6);
    }

    .root label {
      font-weight: var(--font-weight-medium);
      user-select: none;
      cursor: pointer;
      padding: 0 --spacing(3);
    }

    .root input {
      appearance: none;
      border-radius: 50%;
      width: 20px;
      height: 20px;
      border: 1px solid var(--color-ice-500);
      transition: all 0.2s;
      position: relative;
      cursor: pointer;
      top: 5px;
    }

    .root input:checked {
      background-image: radial-gradient(var(--color-blue-500) 50%, transparent 54%);
    }

    .root input:disabled {
      background: #eef2f4;
    }

    .root input:disabled ~ label {
      cursor: auto;
    }

    .root input:disabled:checked {
      background-image: radial-gradient(var(--color-ice-500) 50%, transparent 54%);
    }

    .root input:hover:not(:disabled) {
      border-color: var(--color-blue-500);
    }

    .root input:hover:not(:disabled) ~ label {
      color: var(--color-ice-900);
    }

    .root input:not(:disabled) ~ label:hover {
      color: var(--color-ice-900);
    }
  }
</style>
